import { useMemo } from 'react';

import type { Location } from '../../../../entities/post/models';
import type { TableColumnConfig } from '../../../../shared/components/data-table';
import { DataTable } from '../../../../shared/components/data-table';
import { TableHeader } from './table-header';
interface Props {
  locationData: Location[];
  onLocationClick?: (location: Location, event: React.MouseEvent) => void;
  isLoading?: boolean;
}

export function LocationTable({ locationData, onLocationClick, isLoading }: Props) {
  const columns = useMemo(
    (): TableColumnConfig<Location>[] => [
      {
        key: 'name',
        header: 'Locations',
        size: 'auto',
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'postCount',
        header: 'Volume',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalViews',
        header: 'Views',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalLikes',
        header: 'Likes',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalShares',
        header: 'Shares',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalComments',
        header: 'Comments',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
    ],
    [],
  );

  const handleLocationClick = (location: Location, event: React.MouseEvent) => {
    onLocationClick?.(location, event);
  };

  return (
    <DataTable
      data={locationData}
      header={<TableHeader title="Location overview" />}
      columns={columns}
      onRowClick={handleLocationClick}
      pageSize={5}
      showIndexColumn={false}
      isLoading={isLoading}
    />
  );
}
